module.exports = __webpack_public_path__ + "static/img/4.3748a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.png
// module id = q/uz
// module chunks = 1